module.exports = __webpack_public_path__ + "static/media/  (102).57a0eb1b.jpg";